(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grunvik-size-finder-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-zsx-finder]').forEach(function (finder) {
      if (finder.dataset.bound) return;
      finder.dataset.bound = '1';
      var unit = finder.getAttribute('data-default-unit') === 'in' ? 'in' : 'cm';
      var unitBtns = finder.querySelectorAll('.zsx__unit-btn');
      var unitTags = finder.querySelectorAll('[data-zsx-unit-tag]');
      var calfInput = finder.querySelector('[data-zsx-calf]');
      var ankleInput = finder.querySelector('[data-zsx-ankle]');
      var resultEl = finder.querySelector('[data-zsx-result]');
      var emptyMsg = resultEl ? resultEl.innerHTML : '';
      var rows = Array.prototype.slice.call(finder.querySelectorAll('[data-zsx-size]'));
      var sizes = rows.map(function (r) {
        return { label: r.getAttribute('data-label'),
          calfMin: parseFloat(r.getAttribute('data-calf-min')), calfMax: parseFloat(r.getAttribute('data-calf-max')),
          ankleMin: parseFloat(r.getAttribute('data-ankle-min')), ankleMax: parseFloat(r.getAttribute('data-ankle-max')) };
      }).filter(function (s) { return !isNaN(s.calfMin) && !isNaN(s.calfMax); });

      function toCm(v) { return unit === 'in' ? v * 2.54 : v; }
      function recommend() {
        var raw = parseFloat(calfInput.value);
        if (isNaN(raw) || raw <= 0) { resultEl.innerHTML = emptyMsg; return; }
        var calf = toCm(raw);
        var ankleRaw = parseFloat(ankleInput.value);
        var ankle = (!isNaN(ankleRaw) && ankleRaw > 0) ? toCm(ankleRaw) : null;
        var allMin = Math.min.apply(null, sizes.map(function (s) { return s.calfMin; }));
        var allMax = Math.max.apply(null, sizes.map(function (s) { return s.calfMax; }));
        if (calf < allMin) {
          var sm = sizes.slice().sort(function (a, b) { return a.calfMin - b.calfMin; })[0];
          resultEl.innerHTML = '<span class="zsx__result-size">' + sm.label + '</span><span class="zsx__result-sub">Below our smallest range \u2014 may feel roomy. Our 30-day guarantee has you covered.</span>';
          return;
        }
        if (calf > allMax) {
          resultEl.innerHTML = '<span class="zsx__result-sub">Your calf is above our largest range \u2014 reach out before ordering.</span>';
          return;
        }
        var contained = sizes.filter(function (s) { return calf >= s.calfMin && calf <= s.calfMax; });
        var pool = contained.length ? contained : sizes;
        pool.forEach(function (s) { s._d = Math.abs(calf - (s.calfMin + s.calfMax) / 2); });
        pool.sort(function (a, b) { return a._d - b._d; });
        var best = pool[0];
        var others = contained.filter(function (s) { return s.label !== best.label; });
        var sub = others.length
          ? 'Also fits ' + others.map(function (s) { return s.label; }).join(' & ') + ' \u2014 size up for the easiest zip.'
          : 'Prefer an easier zip? Sizing up is always fine.';
        if (ankle !== null && !isNaN(best.ankleMax) && ankle > best.ankleMax) {
          sub += ' Your ankle is a touch above this size \u2014 consider one up.';
        }
        resultEl.innerHTML = 'We\u2019d suggest <span class="zsx__result-size">' + best.label + '</span><span class="zsx__result-sub">' + sub + '</span>';
      }
      unitBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          unit = btn.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
          unitBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          unitTags.forEach(function (t) { t.textContent = unit; });
          recommend();
        });
      });
      calfInput.addEventListener('input', recommend);
      ankleInput.addEventListener('input', recommend);
      unitBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false'); });
      unitTags.forEach(function (t) { t.textContent = unit; });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grunvik-zipsit-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(el) {
    el.classList.add('is-visible');
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-zhw]');
    Array.prototype.forEach.call(sections, function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      if (el.getAttribute('data-animate') !== 'true' || !('IntersectionObserver' in window)) {
        reveal(el);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

      io.observe(el);
      el._zhwObserver = io;
    });
  }

  function replay(el) {
    if (!el) return;
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var els = e.target.querySelectorAll('[data-zhw]');
    Array.prototype.forEach.call(els, function (el) {
      if (el._zhwObserver) el._zhwObserver.disconnect();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest ? e.target.closest('[data-zhw]') : null;
    replay(host);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
